<template>
  <div class="wrapper">
    <HeaderMainHeader v-if="data?.header?.menuItems" :menu-items="data.header.menuItems" />
    <main class="page-main">
      <BreadcrumbsBreadcrumb
        v-if="data?.breadcrumbs && data.breadcrumbs.length"
        :nav-links="data.breadcrumbs" />
      <component :is="getViewByAlias(data.alias)" v-if="data?.alias" :data="data" />
    </main>
    <FooterMainFooter
      v-if="data?.footer"
      :main-footer="{
        recruitment: {
          figureImg: data.footer.contactImage ?? null,
          mail: data.footer.contactEmail ?? null,
          phoneNumber: data.footer.contactPhoneNumber ?? null,
          rte: data.footer.contactText ?? null,
        },
        contact: {
          rte: data.footer.address ?? null,
          socialLinks: data.footer.socialItems ?? null,
        },
        legal: data.footer.footerItems ?? null,
      }" />
  </div>
</template>

<script lang="ts" setup>
import type { ContentResponseModel } from '@api';
import { useEpiInit } from '@base/composables/useEpiInit';
import type { OgType } from '@base/types/models';

const { path, query } = useRoute();
const { getContent } = useApi();

const { inEditModeAndEditable } = useLiveEdit(query.epieditmode === 'True');

const { data, refresh, error } = await useAsyncData<ContentResponseModel | null | undefined>(
  path,
  async () => getContent(path, inEditModeAndEditable.value)
);

if (!data.value) {
  throw createError({
    statusCode: error.value?.statusCode || 500,
    fatal: true,
  });
}

useEpiInit(refresh);

useSeoMeta({
  title: () => data.value?.metadata?.title ?? '',
  description: () => data.value?.metadata?.description,
  robots: () => data.value?.metadata?.robots,
  ogTitle: () => data.value?.metadata?.openGraph?.title,
  ogDescription: () => data.value?.metadata?.openGraph?.description,
  ogType: () => (data.value?.metadata?.openGraph?.type as OgType) ?? '',
  ogUrl: () => data.value?.metadata?.openGraph?.url,
});
</script>

<style lang="scss" scoped>
.page-main {
  display: block;
  grid-area: pageMain;
}
</style>
